import type { HealthItem } from '../../routes/settings/ownerConsoleTypes'
import { OWNER_BORDER, OWNER_PANEL, OWNER_STATUS } from './ownerTheme'

export default function HealthStrip({ items }: { items: HealthItem[] }) {
  return (
    <div className="rounded-2xl border px-4 py-3" style={{ borderColor: OWNER_BORDER, backgroundColor: OWNER_PANEL }}>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-5">
        {items.map((item) => (
          <div key={item.id} className="flex items-center gap-3">
            <span
              className="h-2.5 w-2.5 rounded-full"
              style={{
                backgroundColor: OWNER_STATUS[item.status],
                boxShadow: `0 0 12px ${OWNER_STATUS[item.status]}55`,
              }}
            />
            <div className="min-w-0">
              <div className="text-xs text-white/55">{item.label}</div>
              <div className="text-sm text-white">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
